import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { Page, Msg, LoadMore, Toast, Panel, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import EnumService from 'services/enum2';
import CommonFns from 'functions/common.ts';
import CropFreeIcon from '@material-ui/icons/CropFree';
import Http from 'services/http2';
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载

/**
 * 检验单列表
 *
 */

function IqcList(props) {
  const Config = {
    purchase: {
      apiPath: '/verify/order/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/iqc/detail',
      searchBarPlaceholder: '供应商编码/名称、物料编码/名称/规格',
      tabs: ['全部', '检验中', '待发出', '待确认', '退回'],
      countApi: '/verify/order/getVerifyCount',
      arrEnumField: [
        { mainKey: 'B02_Verify_Status', subKey: 'status', value: 'statusName' },
        {
          mainKey: 'B02_Verify_Result_Flag',
          subKey: 'resultFlag',
          value: 'resultFlagName'
        },
        {
          mainKey: 'B02_Verify_SourceOrderType',
          subKey: 'sourceOrderType',
          value: 'sourceOrderTypeName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        }
      ],
      countTransform: (data, self) => {
        let { 0: a, 5: b, 1: c, 2: d } = data;
        setCount([undefined, a, b, c, d]);
      },
      tabConfig: [
        undefined, //全部
        [0], // 检验中
        [5], //待发出
        [1], //待确认
        [2] //退回
      ]
    },
    sale: {
      apiPath: '/verify/customerOrder/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/customer/iqc/detail',
      searchBarPlaceholder: '客户名称/编码、产品名称/编码/规格',
      tabs: ['全部', '待确认'],
      countApi: '/verify/customerOrder/getVerifyCount',
      arrEnumField: [
        { mainKey: 'B02_Verify_Status', subKey: 'status', value: 'statusName' },
        {
          mainKey: 'B02_Verify_Result_Flag',
          subKey: 'resultFlag',
          value: 'resultFlagName'
        },
        {
          mainKey: 'B02_Verify_SourceOrderType',
          subKey: 'sourceOrderType',
          value: 'sourceOrderTypeName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        }
      ],
      countTransform: (data, self) => {
        let { 1: a } = data;
        setCount([undefined, a]);
      },
      tabConfig: [
        undefined, //全部
        [1] // 待确认
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    self
  } = useList(props, config);

  const [dateQueryRangeTypeList, setDateQueryRangeTypeList] = useState([]);
  const [dateQueryRangeType, setDateQueryRangeType] = useState('1');
  const [wxReady, setWxReady] = useState(false); // 是否允许移动扫码
  const [sourceNo, setSourceNo] = useState(''); // 来源单号搜索

  //初始化默认企业
  useEffect(() => {
    self.init();
    EnumService.getList('B2b_OrderDate_QueryRangeType').then(data => {
      if (data.length > 0) {
        setDateQueryRangeTypeList(
          data.filter(item => !['99'].includes(item.subKey))
        );
      }
    });
    initWx();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self, dateQueryRangeType]);

  self.beforeSearch = async function () {
    self.searchQueries = {
      status: config.tabConfig[currentTab],
      orderStatus: undefined,
      sourceVfoXkNo: self.searchQueries.sourceVfoXkNo,
      dateQueryRangeType: dateQueryRangeType
    };
  };

  function dateQueryRangeTypeChange(e) {
    let id = e.target.value;
    setDateQueryRangeType(id);
  }

  function sourceNoChange(e) {
    let value = e.target.value;
    setSourceNo(value);
    self.searchQueries.sourceVfoXkNo = value;
    if (value === '') {
      handleSearch();
    }
  }

  function handleSearch() {
    self.search(true, 1);
  }

  /** 扫码搜索 begen */

  function initWx() {
    const userAgent = window.navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

    //IOS暂不支持扫码
    if (isIOS) {
      return;
    }
    let wx = window.wx;
    let url = window.location.href.split('#')[0];
    Http.post('/api/mp', { url, apiPath: '/initJsapi' }).then(rs => {
      if (rs.success) {
        let data = rs.data;
        if (!data.appId) {
          return;
        }
        wx.config({
          ...data,
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          jsApiList: ['scanQRCode', 'chooseImage', 'getNetworkType'] // 必填，需要使用的JS接口列表
        });
        wx.ready(() => {
          setWxReady(true);
        });
        wx.error(function (res) {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        });
      }
    });
  }

  // 钉钉扫码搜索
  function dingScanSearch() {
    dd.ready(function () {
      dd.biz.util.scan({
        type: 'all', // type 为 all、qrCode、barCode，默认是all。
        onSuccess: function (data) {
          setSourceNo(data.text);
          self.searchQueries.sourceVfoXkNo = data.text;
          handleSearch();
        },
        onFail: function (err) {
          // alert(JSON.stringify(err));
        }
      });
    });
  }

  // 扫码搜索
  function scanSearch() {
    if (dd.env.platform !== 'notInDingTalk') {
      // 在钉钉环境内执行扫码逻辑
      this.dingScanSearch();
      return;
    }

    let wx = window.wx;

    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      success: function (res) {
        //一维码：{reultStr: 'code128,abcd123', errMsg: 'scanQRCode:ok'}
        //二维码：{reultStr: 'abcd123', errMsg: 'scanQRCode:ok'}
        let result = res.resultStr;
        let arrCode = result.split(',');
        let code = arrCode[arrCode.length - 1];
        setSourceNo(code);
        self.searchQueries.sourceVfoXkNo = code;
        handleSearch();
      },
      fail: function (res) {
        // alert(JSON.stringify(res));
      }
    });
  }

  /** 扫码搜索 end */

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            {wxReady && (
              <div className="wrap m-flex-box fixed-bottom">
                {
                  <Button
                    type="default"
                    onClick={scanSearch}
                    className="m-flex-item u-btn u-btn_primary"
                  >
                    <CropFreeIcon fontSize="inherit" />
                    扫码搜索
                  </Button>
                }
              </div>
            )}

            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            {props.type === 'purchase' && (
              <div>
                <Select
                  style={{
                    width: '50%',
                    marginLeft: '16px',
                    marginTop: '5px'
                  }}
                  value={dateQueryRangeType}
                  onChange={e => dateQueryRangeTypeChange(e)}
                >
                  {dateQueryRangeTypeList.map((item, index) => (
                    <MenuItem key={index} value={item.subKey}>
                      {item.subValue}
                    </MenuItem>
                  ))}
                </Select>

                <TextField
                  style={{
                    verticalAlign: 'bottom',
                    width: '90%',
                    marginLeft: '16px',
                    paddingRight: '5px',
                    marginTop: '0'
                  }}
                  label="来源单号"
                  value={sourceNo}
                  onChange={event => {
                    sourceNoChange(event);
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        onClick={() => {
                          handleSearch();
                        }}
                      >
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                  variant="standard"
                />
              </div>
            )}

            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.vfoXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.vfoInnerNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('iqc', item.status)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.innerCustomerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>来源单据</label>
                          <div>
                            {item.sourceShowNo}{' '}
                            <span className="gray">
                              {item.sourceOrderTypeName}
                            </span>
                          </div>
                        </li>
                        <li>
                          <label>制单日期</label>
                          <div>{formatDate(item.createTime, 'YYYY-MM-DD')}</div>
                        </li>
                        <li>
                          <label>制单人</label>
                          <div>{item.createName}</div>
                        </li>
                        <li>
                          <label>检验结果</label>
                          <div>
                            <span
                              className={
                                'u-sign ' +
                                CommonFns.getStatusClass(
                                  'iqcResult',
                                  item.resultFlag
                                )
                              }
                            >
                              {item.resultFlagName}
                            </span>
                          </div>
                        </li>
                        <li>
                          <label>同步状态</label>
                          <div>
                            <span
                              className={
                                'u-sign ' +
                                CommonFns.getStatusClass(
                                  'sync',
                                  item.syncStatus
                                )
                              }
                            >
                              {item.syncStatusName}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

IqcList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(IqcList);
